import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Label } from '../../atoms/label';
import { connect, useStore } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import useMedia from 'use-media';
import { useRtoaster } from '../../../hooks/useRtoaster';
import commonUtil from '../../../common/commonUtil';
import { apiKeyCheck, getServiceCheck, versionGetApi } from '../../../const';
import Const from '../../../const/Const';
import messageConst from '../../../const/messageConst';
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import { BreadCrumb } from '../../molecules/breadCrumb';
import { ErrorMassage } from '../../molecules/errorMassage';
import { MealInfoComf } from '../../molecules/mealInfoComf';
import { PrivilegeUseComf } from '../../molecules/privilegeUseComf';
import { ReserveInfoComf } from '../../molecules/reserveInfoComf';
import { RoomInfoComf } from '../../molecules/roomInfoComf';
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/common/privilege_icon.css';
import './../../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css';

const MembershipBookingConfirmDetailContainer = (props) => {
    const {
        login,
        membershipReserveComf,
        setMembershipReserveComf,
        onClickOpenCancelPopupWindow,
        mealInfoList,
        setMealInfoList,
        otherMenuInfoList,
        setOtherMenuInfoList,
        setInputUserInfo,
        membershipReserveInfo,
        setMembershipReserveInfo,
        membershipSearchParam,
        setMembershipSearchParam,
        setMembershipCancelReserveComf,
        resvKaiinken,
        setRight,
        serviceCheckInfo,
        setServiceCheckInfo,
        setLoginType,
    } = props;

    const loginType = login.loginType;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const store = useStore();
    const history = useHistory();

    //表示用ステート
    const [reserveInfo,setReserveInfo] = useState({});
    const [reserveRoomInfo,setReserveRoomInfo] = useState([]);
    const [reserveMealInfo,setReserveMealInfo] = useState([]);
    const [reservePrivilegeInfo,setReservePrivilegeInfo] = useState([]);
    const [linkList, setLinkList] = useState([]);
    const [machiPlanCheckFlg, setMachiPlanCheckFlg] = useState([]);
    const [machiMongon, setMachiMongon] = useState("");
    const isCrawl = login.loginType === 'CRAWL';

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessageBox: [], errorFlg: false, });

    // rtoasterタグ生成
    useRtoaster();

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if(Object.keys(state).length !== 0){
            apiKey = state.apiKey;
        }
        if(apiKey === null){
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
        if(apiKey){
            common.doPost(apiKeyCheck, {apikey:apiKey}, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if(!res.data){
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE"});
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        //予約内容のセット
        if(membershipReserveComf != undefined && Object.keys(membershipReserveComf).length != 0){
            reserveInfoSet();
            reserveRoomInfoSet();
            setReserveMealInfo(membershipReserveComf.foodList);
            setReservePrivilegeInfo(membershipReserveComf.shokaKenriList);
        }
        if (loginType === "MEMBER") {
            setLinkList([{ path: "/reserve/top", label: "HOME" }, { path: "/reserve/hotel/search", label: "ホテル予約" }]);
        } else if (loginType === "CRAWL") {
            setLinkList([{ path: "/reserve/hotel/crawlSearch", label: "ホテル予約" }]);
        }
        setErrorInfo({ errorMessageBox: [], errorFlg: false, })

        // サービスチェック取得
        requestGetServiceCheck();

        // ログインタイプ取得
        setLoginType(loginType);

        let machiMongon = "";
        const sumRoomCnt = membershipReserveComf.hakuCnt * membershipReserveComf.roomCnt;
        let reserveRoomCnt = 0;
        membershipReserveComf.roomList.map((roomInfo) => {
            if(roomInfo.machiList){
                reserveRoomCnt += roomInfo.machiList.length;
            }
        })
        if(membershipReserveComf.machiFlg === '1'){
            if(sumRoomCnt !== reserveRoomCnt){
                machiMongon = '一部交換待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
            } else{
                machiMongon = '交換待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
            }
        }else if(membershipReserveComf.machiFlg === '2'){
            if(sumRoomCnt !== reserveRoomCnt){
                machiMongon = "一部キャンセル待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。";
            }else{
                machiMongon = 'キャンセル待ちとなります。\nお部屋の用意ができ次第、ご連絡させていただきます。'
            }
        }
        setMachiMongon(machiMongon)
        
        
    }, [membershipReserveComf]);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    // プラン変更可能チェック
    const checkChangePlan = () => {
        let errorFlg = false;
        let errorMessageBox = [];
        let strToday = commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd");
        const termCnt = commonUtil.getNights(strToday, membershipReserveComf.checkInDate, "-") + 1;
        if (termCnt <= Const.CHANGEABLE_TERM) {
            errorFlg = true;
            errorMessageBox.push(messageConst.CHANGE_LIMIT_ERROR);
            setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
            return !errorFlg;
        }
        let availableFlg = false;
        login.memberInfo?.forEach(info => {
            info.memberList?.data.kaiinInfoList.forEach(value => {
                if (membershipSearchParam.keiyakuNo == value.keiyakuNo) {
                    availableFlg = true;
                }
            })
        })
        if (!isCrawl && !availableFlg) {
            errorFlg = true;
            errorMessageBox.push(messageConst.ILLEGAL_RESERVE_ERROR);
            setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
            return !errorFlg;
        }
        const foodList = membershipReserveComf.foodList;
        if (foodList && foodList.length > 0) {
            let foodErrFlg = false;
            foodList.forEach(foodInfo => {
                let dinnerCnt = 0;
                let breakfastCnt = 0;
                foodInfo.foodTimeList?.forEach(value => {
                    if (value.jikantaiKbn == "2") {
                        dinnerCnt++;
                    } else if (value.jikantaiKbn == "3") {
                        breakfastCnt++;
                    }
                })
                if (dinnerCnt > 1 || breakfastCnt > 1) {
                    foodErrFlg = true;
                }
            })
            if (foodErrFlg) {
                errorFlg = true;
                errorMessageBox.push(messageConst.ILLEGAL_RESERVE_ERROR);
            }
        }
        setErrorInfo({errorFlg: errorFlg, errorMessageBox: errorMessageBox});
        return !errorFlg;
    }

    const getPlanName = (membershipReserveComf) => {
        // 予約するときに素泊まりはplanCdを連携しない仕様なので取得できない
        return membershipReserveComf.planCd ? membershipReserveComf.planName : "";
    }

    // サービスチェック取得処理
    const requestGetServiceCheck = () => {
        if (!membershipReserveComf || !membershipReserveComf.roomList) return;

        // 予約部屋数取得
        const roomTypeCdList = [];
        membershipReserveComf.roomList.forEach(value => {
            const roomType = value.roomType;
            const roomTypeCd = roomTypeCdList.find(x=> x.roomTypeCd === roomType);
            if (roomTypeCd) {
                roomTypeCd.yoyakuRoomSu += 1;
            } else {
                roomTypeCdList.push({
                    roomTypeCd:roomType,
                    yoyakuRoomSu: 1
                });
            }
        });
        // サービスチェック取得
        const req = {
            keiyakuNo: membershipReserveComf.keiyakuNo,
            shisetsuCd: membershipReserveComf.shisetsuCd,
            riyoDate: membershipReserveComf.checkInDate,
            hakuCnt: membershipReserveComf.hakuCnt,
            tsuzukigaraCd: membershipReserveComf.relationCd,
            roomTypeList: roomTypeCdList,
            riyoKaiinkenSyubetCd: membershipReserveComf.riyoKaiinkenSyubetCd,
        }
        common.doPostRef(getServiceCheck, req, membershipReserveComf.roomList, afterGetServiceCheck);
    }

    // サービスチェック取得後処理
    const afterGetServiceCheck = (res, roomList) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setServiceCheckInfo({
                kozafurikaeKanoKbn: data.kozafurikaeKanoKbn,
                kozafurikaeKiyakuMongon: data.kozaMongon,
                sciKanoFlg: data.sciKanoFlg,
                sciKiyakuMongon: data.sciMongon,
                scoKanoFlg: data.scoKanoFlg,
                scoKiyakuMongon: data.scoMongon,
                nonstopCheckInKanoFlg: data.nonstopCheckinKanoFlg,
                nonstopKiyakuMongon: data.nonstopMongon,
                kenrishokaYoFlg: data.kenrishokaYoFlg,
                homeFlKanoFlg: data.homeFlKanoFlg
            });
        }
    }

    //予約内容セット
    const reserveInfoSet = () =>{
        let reserveObj = {
            checkin:dateForm(membershipReserveComf.checkInDate),
            checkout:dateForm(membershipReserveComf.checkOutDate),
            hakusu:membershipReserveComf.hakuCnt.toString(),
            facilityName: membershipReserveComf.shisetsuName,
            // 予約するときに素泊まりはplanCdを連携しない仕様なので取得できない
            planName:getPlanName(membershipReserveComf),
            roomNum:membershipReserveComf.roomList?.length,
            reservationNo:membershipReserveComf.yoyakuNo,
            machiFlg: membershipReserveComf.machiFlg,
            ownerNo: membershipReserveComf.ownerNo,
            adultDinnerRyokin: membershipReserveComf.adultDinnerRyokin,
            breakfastTsukiPlanFlg: membershipReserveComf.breakfastTsukiPlanFlg,
            thanksFlg: membershipReserveComf.thanksFlg
        }
        setReserveInfo(reserveObj);
    }
    //部屋情報セット
    const reserveRoomInfoSet = () =>{
        let roomList = [];
        let newMachiPlanCheckFlg = false;
        membershipReserveComf.roomList.map((roomInfo) => {
            let roomNumList = []
            if(roomInfo.menCnt !== 0){
                let obj = {parson:"大人（男性）" ,num:roomInfo.menCnt + "人"}
                roomNumList.push(obj);
            }
            if(roomInfo.womenCnt !== 0){
                let obj = {parson:"大人（女性）" ,num:roomInfo.womenCnt + "人"}
                roomNumList.push(obj);
            }
            if(roomInfo.childCnt !== 0){
                let obj = {parson:"小学生" ,num:roomInfo.childCnt + "人"}
                roomNumList.push(obj);
            }
            if(roomInfo.preschoolerCnt !== 0){
                let obj = {parson:"幼児（3歳〜5歳）" ,num:roomInfo.preschoolerCnt + "人"}
                roomNumList.push(obj);
            }
            if(roomInfo.babyCnt !== 0){
                let obj = {parson:"乳児（0歳〜2歳）" ,num:roomInfo.babyCnt + "人"}
                roomNumList.push(obj);
            }
            let machiRoomFlg = false;
            if (roomInfo?.machiList?.length) {
                machiRoomFlg = !!roomInfo.machiList.filter(value => value.kenriRiyoJKbn == "4" || value.kenriRiyoJKbn == "6")?.length
            }
            if (machiRoomFlg) {
                newMachiPlanCheckFlg = true;
            }
            if(roomInfo.machiList){
                roomInfo.machiList.map((machi) => {
                    machi.machiDate = dateForm(machi.machiDate);
                })
            }
            
            let roomObj = {
                roomNums:roomNumList,
                roomCount:roomInfo.humanCnt,
                roomType:roomInfo.roomType,
                hyjRmType:roomInfo.hyjRmType,
                machiRoomFlg: machiRoomFlg,
                machiList:roomInfo.machiList,
            }
            roomList.push(roomObj);
        })
        setMachiPlanCheckFlg(newMachiPlanCheckFlg);
        setReserveRoomInfo(roomList);
    }


    //yyyy-mm-ddをyyyy年mm月dd日(曜日)形式に変換
    const dateForm = (res) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        var dateArr = res.split("-")
        let date = new Date(dateArr[0],dateArr[1] - 1,dateArr[2]);
        let convert = dateArr[0]+ "年" +dateArr[1].replace(/^0+/, '')+ "月" + dateArr[2].replace(/^0+/, '')+ "日" + "(" +  youbi[date.getDay()]+ ")";

        return convert;
    }
    // // membershipReserveComfのfoodList(getReserveInfo APIのfoodList)を予約画面のfoodListに変換
    // const getInputUserInfoFoodAndCourseList = (comfFoodList) => {
    //     if (!comfFoodList) {
    //         return null;
    //     }
    //     const foodList = [];
    //     const foodCourseList = [];
    //     for (const food of comfFoodList) {
    //         if (!food.foodTimeList) {
    //             continue;
    //         }
    //         for (const foodTime of food.foodTimeList) {
    //             foodList.push(foodTime);
    //             if (!foodTime.foodCourseList) {
    //                 continue;
    //             }
    //             for (const course of foodTime.foodCourseList) {
    //                 foodCourseList.push({ restaurantCd: foodTime.restaurantCd, ...course });

    //             }
    //         }
    //     }
    //     return { foodList, foodCourseList };


    // }
    const getInputUserInfo = () => {
        // const { foodList, foodCourseList } = getInputUserInfoFoodAndCourseList(membershipReserveComf.foodList);
        let inputAdultSum = 0;
        let menSum = 0;
        let womenSum = 0;
        let childSum = 0;
        let preschoolerSum = 0;
        let babySum = 0;
        membershipReserveComf.roomList.forEach(roomObj => {
            menSum += Number(roomObj.menCnt);
            womenSum += Number(roomObj.womenCnt)
            childSum += Number(roomObj.childCnt)
            preschoolerSum += Number(roomObj.preschoolerCnt)
            babySum += Number(roomObj.babyCnt)
        })
        inputAdultSum = menSum + womenSum;
        const ret = {
            adultCnt: inputAdultSum,
            childCnt: childSum,
            preschoolerCnt: preschoolerSum,
            babyCnt: babySum,
            inputRoomList: membershipReserveComf.roomList.map(r => {return {...r, roomTypeName: r.hyjRmType}}),
            foodList: membershipReserveComf.foodList ? membershipReserveComf.foodList : [],
            allergyKbn: membershipReserveComf.allergyKbn,
            allergyBiko: membershipReserveComf.allergyBiko,
            foodRequest: membershipReserveComf.foodRequest,
            daihyouName: membershipReserveComf.daihyouName,
            daihyouNameKana: membershipReserveComf.daihyouNameKana,
            mainPhoneKbn: membershipReserveComf.mainPhoneKbn,
            mainPhoneNumber: membershipReserveComf.mainPhoneNumber,
            contactPhoneNumber: membershipReserveComf.contactPhoneNumber,
            contactMailAddress: membershipReserveComf.contactMailAddress,
            relationCd: membershipReserveComf.relationCd,
            prefectureCd: membershipReserveComf.prefectureCd,
            transportCd: membershipReserveComf.transportCd,
            carCnt: membershipReserveComf.carCnt,
            busTime: membershipReserveComf.busTime,
            kozafurikaeFlg: membershipReserveComf.kozafurikaeFlg,
            smartCheckInFlg: membershipReserveComf.smartCheckInFlg,
            smartCheckOutFlg: membershipReserveComf.smartCheckOutFlg,
            nonstopCheckInFlg: membershipReserveComf.nonstopCheckInFlg,
            biko: membershipReserveComf.biko,
            kakuninMailKiboKbn: membershipReserveComf.kakuninMailKiboKbn,
            confirmReserveMail: membershipReserveComf.kakuninMailKiboKbn ? membershipReserveComf.kakuninMailAddress : "",
            applicantFlg: membershipReserveComf.applicantFlg
        };
        return ret;
    }

    //プラン変更ボタン
    const onClickPlanChange = () => {
        // 変更可能チェック
        if (checkChangePlan()) {
            //
            setInputUserInfo(getInputUserInfo());
            //画面遷移
            setMembershipReserveComf({ ...membershipReserveComf, pageKbn: "membershipResvComf" });
            history.push("/reserve/hotel/changePlan");
        }
    }

    // // お客様情報入力画面に初期表示するコース
    // const toMealInfoCourse = (srcCourse) => {
    //     if (!srcCourse) {
    //         return [];
    //     }

    //     return srcCourse.map(src => {
    //         return {
    //             courseCd: src.foodCourseCd,
    //             courseName: src.foodCourseName,
    //             courseNum: src.targetCnt
    //         };
    //     });

    // }

    //人数・時間変更ボタン
    const onClickTimeChange = () => {
        // 変更可能チェック
        if (checkChangePlan()) {
            // 予約内容取得処理
            setMembershipReserveInfo({
                ...membershipReserveInfo,
                honkanShisetsuCd: membershipReserveComf.honkanShisetsuCd,
                planShohinCd: membershipReserveComf.planShohinCd,
                planCategoryDetailCd: membershipReserveComf.planCategoryDetailCd,
                shisetsuName: membershipReserveComf.shisetsuName,
                shisetsuCd: membershipReserveComf.shisetsuCd,
                yoyakuNo: membershipReserveComf.yoyakuNo,
                planCd: membershipReserveComf.planCd,
                machiFlg: membershipReserveComf.machiFlg,
                planName: getPlanName(membershipReserveComf),
                dinnerTsukiPlanFlg: membershipReserveComf.dinnerTsukiPlanFlg,
                breakfastTsukiPlanFlg: membershipReserveComf.breakfastTsukiPlanFlg,
                planRyokinTotal: membershipReserveComf.totalRoomPrice,
                thanksFlg: membershipReserveComf.thanksFlg,
                assignFlg: membershipReserveComf.assignFlg,
                changeFlg: true,
                changeType: 'member'
            })
            let adultSum = 0;
            let childSum = 0;
            membershipReserveComf.roomList.forEach(room => {
                adultSum += room.menCnt + room.womenCnt;
                childSum += room.childCnt + room.preschoolerCnt + room.babyCnt;
            })
            let kaiinkenCd = "";
            let kaiinkenNo = "";
            login.memberInfo?.forEach(info => {
                info.memberList?.data.kaiinInfoList.forEach((value, index) => {
                    if (membershipSearchParam.keiyakuNo == value.keiyakuNo) {
                        kaiinkenCd = value.ownerCd;
                        kaiinkenNo = value.ownerNo;
                    }
                })
            })
            if (loginType === "CRAWL") {
                kaiinkenCd = membershipReserveComf.ownerCd || "";
                kaiinkenNo = membershipReserveComf.ownerNo || "";
            }
            setMembershipSearchParam({
                checkInDate: membershipReserveComf.checkInDate,
                checkOutDate: membershipReserveComf.checkOutDate,
                nights: membershipReserveComf.hakuCnt,
                adultCnt: adultSum,
                childCnt: childSum,
                roomCnt: membershipReserveComf.roomList.length,
                keiyakuNo: membershipSearchParam.keiyakuNo,
                riyoKaiinkenSyubetCd: membershipSearchParam.riyoKaiinkenSyubetCd,
                kaiinkenCd: kaiinkenCd,
                kaiinkenNo: kaiinkenNo,
                memberCd: resvKaiinken.length? resvKaiinken[0].memberCd : "",
            });
            // src\components_membership_hotel\organisms\hotel\membershipInputUserContainer.jsx　で設定しているから不要
            // let newMealList = [];
            // let newOtherMenuList = [];
            // if (membershipReserveComf.foodList) {
            //     let dateList = commonUtil.getDateList(membershipReserveComf.checkInDate, membershipReserveComf.checkOutDate, "yyyy-MM-dd");
            //     for (let i = 1; i <= membershipReserveComf.foodList.length; i++) {
            //         let resFoodInfo = membershipReserveComf.foodList.find(value => i == value.dayCnt).foodTimeList;
            //         let dinnerData = {};
            //         let lunchData = {};
            //         let breakfastData = {};
            //         resFoodInfo.forEach(value => {
            //             let dispCourse = "";
            //             let courseList = value.courseList.map(value => {
            //                 dispCourse += (dispCourse == "" ? "" : "、 ") + value.foodCourseName + "：" + value.targetCnt + "人";
            //                 return {courseCd: value.foodCourseCd, courseName: value.foodCourseName, courseNum: value.targetCnt }
            //             })
            //             if(value.jikantaiKbn == "2"){
            //                 dinnerData = {
            //                     nights: i,
            //                     restaurantCd: value.restaurantCd,
            //                     restaurantName: value.restaurantName,
            //                     jikantaiKbn: value.jikantaiKbn,
            //                     restaurantRiyoDate: dateList[i - 1],
            //                     mealTime: value.startTime,
            //                     courseList: toMealInfoCourse(courseList),
            //                     dispCourse: dispCourse,
            //                     doiList: []
            //                 };
            //                 newMealList.push(dinnerData);
            //             } else if (value.jikantaiKbn == "3"){
            //                 breakfastData = {
            //                     nights: i,
            //                     restaurantCd: value.restaurantCd,
            //                     restaurantName: value.restaurantName,
            //                     jikantaiKbn: value.jikantaiKbn,
            //                     restaurantRiyoDate: dateList[i - 1],
            //                     mealTime: value.startTime,
            //                     courseList: toMealInfoCourse(courseList),
            //                     dispCourse: dispCourse,
            //                     doiList: []
            //                 }
            //                 newMealList.push(breakfastData);
            //             } else {
            //                 lunchData = {
            //                     nights: i,
            //                     restaurantCd: value.restaurantCd,
            //                     restaurantName: value.restaurantName,
            //                     jikantaiKbn: value.jikantaiKbn,
            //                     restaurantRiyoDate: dateList[i - 1],
            //                     mealTime: value.startTime,
            //                     courseList: toMealInfoCourse(courseList),
            //                     dispCourse: dispCourse,
            //                     doiList: []
            //                 }
            //                 newOtherMenuList.push(lunchData);
            //             }
            //         })
            //         // newMealList.push(breakfastData);
            //         newMealList.push(dinnerData);
            //     }
            //     //
            //     // setMealInfoList(newMealList);
            //     setOtherMenuInfoList(newOtherMenuList);
            // }

            setInputUserInfo(getInputUserInfo());
            if (membershipReserveComf.shokaKenriList) {
                let rightlist = [];
                membershipReserveComf.shokaKenriList.forEach(value => {
                    rightlist.push({
                        stayDate: value.riyoDate,
                        stayKenriIroKbn: value.shokaKenriIro,
                        stayKenriList: value.shokaList.map(shokaDate => {
                            return { shokaKenriIroKbn: shokaDate.shokaKenriIro, shokaKenriDate: shokaDate.shokaDate }
                        })
                    })
                })
                setRight(rightlist)
            }
            setMembershipReserveComf({ ...membershipReserveComf, pageKbn: "" });
            //画面遷移
            history.push("/reserve/hotel/inputUser");
        }
    }

    //同行者登録ボタン
    const onClickRegistAccompany = () => {
        // 変更可能チェック
        if (checkChangePlan()) {
            setMembershipReserveComf({ ...membershipReserveComf, pageKbn: "membershipResvComf" });
            //画面遷移
            history.push("/reserve/hotel/inputAccompany");
        }
    }

    //キャンセル処理
    const onClickCancel = () => {
        // 変更可能チェック
        if (checkChangePlan()) {
            setMembershipCancelReserveComf({shisetsuCd: membershipReserveComf.shisetsuCd, checkInDate: membershipReserveComf.checkInDate, keiyakuNo: membershipReserveComf.keiyakuNo, yoyakuNo: membershipReserveComf.yoyakuNo});
            onClickOpenCancelPopupWindow()
        }
    }

    // 料金情報
    const priceInfo = () => {
        const dispPriceFlg = membershipReserveComf.totalRoomPrice && membershipReserveComf.totalRoomPrice != 0 && membershipReserveComf.planCd &&
        (membershipReserveComf.breakfastTsukiPlanFlg || membershipReserveComf.dinnerTsukiPlanFlg || membershipReserveComf.thanksFlg ||
        membershipReserveComf?.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE || Const.DISP_PRICE_CODE.includes(membershipReserveComf?.planCategoryDetailCd)) && membershipReserveComf.machiFlg === "0";
        if (dispPriceFlg) {
            return(
                <div className='membership_reserve_cancel_contentarea'>
                        <div className='membership_reserve_cancel_title'>
                        プラン料金
                        </div>
                    <div className='membership_reserve_cancel_body priceArea'>
                        <div className='priceContentLabel'>
                            <Label
                                label={"(サービス料・消費税含む)"}
                                className={"price"}
                            />
                            <div className='price'>合計：￥{Number(membershipReserveComf.totalRoomPrice).toLocaleString()}</div>
                            {membershipReserveComf.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE ?
                                <>
                                    {membershipReserveComf.totalDiscountPrice ?
                                        <>
                                            <Label
                                                label={"全国旅行支援：￥-" + membershipReserveComf.totalDiscountPrice?.toLocaleString()}
                                                className={"price"}
                                            />
                                            <Label
                                                label={"お支払い額：￥" + (membershipReserveComf.totalRoomPrice - (membershipReserveComf.totalDiscountPrice ? membershipReserveComf.totalDiscountPrice : 0))?.toLocaleString()}
                                                className="price redChar"
                                            />
                                        </>
                                        :
                                        <Label
                                            label="全国旅行支援対象外"
                                            className="redChar"
                                        />
                                    }
                                    {membershipReserveComf.totalCouponPrice ?
                                        <>
                                            <Label
                                                label={"割引対象者数：" + membershipReserveComf.discountNum + "人"}
                                                className="price"
                                            />
                                            <Label
                                                label={"地域クーポン：￥" + membershipReserveComf.totalCouponPrice?.toLocaleString()}
                                                className="price"
                                            />
                                        </>
                                        :
                                        <div className='str_padding'></div>
                                    }
                                </>
                                :
                                null
                            }
                        </div>
                        <div className='membership_reserve_cancel_wid'>
                            <div className='priceComment redChar'>{messageConst.PRICE_COMMENT}</div>
                            <div className='priceComment'>{messageConst.TAX_COMMENT}</div>
                            {membershipReserveComf.planCategoryDetailCd == Const.TRAVEL_SUPPORT_CODE ?
                                <>
                                    <div className='priceComment redChar'>{messageConst.TRAVEL_SUPPORT_TARGET_COMMENT}</div>
                                    <div className='priceComment redChar'>{messageConst.TRAVEL_SUPPORT_COMMENT}</div>
                                    {Const.SHISETSU_CODE_TOBA.includes(membershipReserveComf.shisetsuCd) || Const.SHISETSU_CODE_NARUTO.includes(membershipReserveComf.shisetsuCd) ?
                                        <Label
                                            label={messageConst.TRAVEL_SUPPORT_PRICE_COMMENT}
                                            className="priceComment redChar"
                                        />
                                        :
                                        null
                                    }
                                    {membershipReserveComf?.holidayFlg ?
                                        <Label
                                            label={messageConst.TRAVEL_SUPPORT_HOLIDAY_COMMENT}
                                            className="priceComment redChar"
                                        />
                                        :
                                        null
                                    }
                                </>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
            )
        } else {
            return null;
        }
    }

    return (
        <div>
            <div style={{marginLeft:"-40px"}}>
                <BreadCrumb
                    breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                    linkStyle={styles.link}
                    linkList={linkList}
                    lastLabel="予約内容確認"
                    lastLabelClassName="lastLabel"
                />
            </div>
            <div className={isWideTablet ? "membership_reserve_cancel_base2" : "membership_reserve_cancel_base"}>
                <ReserveInfoComf data={reserveInfo} />
                {/* 部屋情報リストでマップする */}
                <RoomInfoComf data={reserveRoomInfo} />
                {/* 食事リストでマップする */}
                <MealInfoComf data={reserveMealInfo} />
                {membershipReserveComf.machiFlg != 0 ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            食事希望欄
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.foodRequest}</div>
                            </div>
                        </div>
                    </div> : null}
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        アレルギー
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.allergyKbn == "1" ? "あり" : membershipReserveComf.allergyKbn == "2" ? "なし" : "わからない"}</div>
                        </div>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_subtitle'>アレルギー内容</div>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.allergyBiko}</div>
                        </div>
                    {membershipReserveComf.machiFlg != 0 ?
                        null
                        :
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_subtitle'>食事要望</div>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.foodRequest}</div>
                            </div>
                    }
                    </div>
                </div>
                {/* 料金エリア */}
                {priceInfo()}
            </div>
            <div className={isWideTablet ? "membership_reserve_cancel_base2" : "membership_reserve_cancel_base"} style={styles.topGrayBorder}>
                {
                    !isCrawl && !membershipReserveInfo.generalFlg ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            予約者ご本人様
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.applicantFlg ? "利用する" : "利用しない"}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        利用代表者
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_subtitle'>氏名（カナ）</div>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.daihyouNameKana}</div>
                        </div>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_subtitle'>氏名（漢字）</div>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.daihyouName}</div>
                        </div>
                    </div>
                </div>
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        利用代表者電話番号
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            {!membershipReserveInfo.generalFlg && (
                            <div className='membership_reserve_cancel_subtitle'>{membershipReserveComf.mainPhoneKbn == "1" ? "自宅" : membershipReserveComf.mainPhoneKbn == "2" ? "会社" : "携帯"}</div>
                            )}
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.mainPhoneNumber}</div>
                        </div>
                    </div>
                </div>
                {!membershipReserveInfo.generalFlg && (
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        予約連絡先電話番号
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.contactPhoneNumber}</div>
                        </div>
                    </div>
                </div>
                )}
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        {"予約連絡先メールアドレス"}
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_info_mail'>{membershipReserveComf.contactMailAddress}</div>
                        </div>
                    </div>
                </div>
                {!membershipReserveInfo.generalFlg && (
                  <div className="membership_reserve_cancel_contentarea">
                      <div className='membership_reserve_cancel_title'>
                          {"会員様とのご関係"}
                      </div>
                      <div className='membership_reserve_cancel_body'>
                          <div className='membership_reserve_cancel_wid five_padding'>
                              <div className='membership_reserve_cancel_info'>{membershipReserveComf.relationName}</div>
                          </div>
                      </div>
                  </div>
                )}
                {!membershipReserveInfo.generalFlg && (
                  <div className="membership_reserve_cancel_contentarea">
                      <div className='membership_reserve_cancel_title'>
                          {"利用代表者の居住地"}
                      </div>
                      <div className='membership_reserve_cancel_body'>
                          <div className='membership_reserve_cancel_wid five_padding'>
                              <div className='membership_reserve_cancel_info'>{membershipReserveComf.prefectureName}</div>
                          </div>
                      </div>
                  </div>
                )}
                {membershipReserveInfo.generalFlg && (
                  <div className="membership_reserve_cancel_contentarea">
                      <div className='membership_reserve_cancel_title'>
                          {"住所"}
                      </div>
                      <div className='membership_reserve_cancel_body'>
                          <div className='membership_reserve_cancel_wid five_padding'>
                            <Label
                              label={
                                  '〒'
                                  + membershipReserveComf.zipCode1
                                  + '-'
                                  + membershipReserveComf.zipCode2
                                  + ' '
                                  + membershipReserveComf.prefecture
                                  + membershipReserveComf.address1
                                  + membershipReserveComf.address2
                                  + membershipReserveComf.address3
                              }
                              className="confirmContentLabel"
                            />
                          </div>
                      </div>
                  </div>
                    )}
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        {"交通機関"}
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.transportName}</div>
                        </div>
                    </div>
                </div>
                {membershipReserveComf.transportCd != 2 ? null :
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"車の場合"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.carCnt + "台"}</div>
                            </div>
                        </div>
                    </div>
                }
                {serviceCheckInfo && serviceCheckInfo.kozafurikaeKanoKbn == "1" ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"口座振替精算"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.kozafurikaeFlg ? "希望する" : "希望しない"}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {serviceCheckInfo && serviceCheckInfo.sciKanoFlg == "1" ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"スマートチェックイン"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.smartCheckInFlg ? "希望する" : "希望しない"}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {serviceCheckInfo && serviceCheckInfo.scoKanoFlg == "1" ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"スマートチェックアウト"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.smartCheckOutFlg ? "希望する" : "希望しない"}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                {serviceCheckInfo && serviceCheckInfo.nonstopCheckInKanoFlg == "1"  ?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"ノンストップチェックイン"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                <div className='membership_reserve_cancel_info'>{membershipReserveComf.nonstopCheckInFlg ? "希望する" : "希望しない"}</div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <div className="membership_reserve_cancel_contentarea">
                    <div className='membership_reserve_cancel_title'>
                        {"その他要望"}
                    </div>
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_info'>{membershipReserveComf.biko}</div>
                        </div>
                    </div>
                </div>
                {/* 権利消化エリア */}
                <PrivilegeUseComf data={reservePrivilegeInfo} />
                {membershipReserveComf.kakuninMailKiboKbn != undefined && membershipReserveComf.kakuninMailKiboKbn != null && !membershipReserveInfo.generalFlg?
                    <div className="membership_reserve_cancel_contentarea">
                        <div className='membership_reserve_cancel_title'>
                            {"予約確認メール"}
                        </div>
                        <div className='membership_reserve_cancel_body'>
                            <div className='membership_reserve_cancel_wid five_padding'>
                                {membershipReserveComf.kakuninMailKiboKbn == "1" ?
                                    <>
                                        <div className='membership_reserve_cancel_info'>希望する</div>
                                        <div className='membership_reserve_cancel_info_mail'>{membershipReserveComf.kakuninMailAddress}</div>
                                    </>
                                    : <div className='membership_reserve_cancel_info'>希望しない</div>
                                }
                            </div>
                        </div>
                    </div>
                    : null
                }
                {machiPlanCheckFlg ? 
                    <div className="membership_reserve_machi_check_contentarea">
                        <Label
                            label={machiMongon}
                            className="membership_reserve_machi_check"
                        />
                        <Label
                            label={"上記確認しました。"}
                            className="confirmContentLabel"
                        />
                    </div>
                :null}
                <div style={errorInfo.errorFlg ? styles.errorDiv : { display: "none" }}>
                    <ErrorMassage style={styles.errorMassage} data={errorInfo.errorMessageBox} />
                </div>
                {membershipReserveInfo.generalFlg || membershipReserveInfo.cancelKbn == "1" ?
                    <>
                        <div className='membership_reserve_change_btn_area'>
                            {!membershipReserveInfo.generalFlg && membershipReserveComf.machiFlg != 0 ? null :
                                <Button buttonText="プラン変更" onClick={onClickPlanChange} className="membership_reserve_plan_btn" />
                            }
                            {membershipReserveComf.machiFlg != 0 ? null :
                                <Button buttonText="人数・レストラン変更" onClick={onClickTimeChange} className="membership_reserve_time_btn" />
                            }
                            {membershipReserveInfo.generalFlg || membershipReserveComf.machiFlg != 0 ? null :
                                <Button buttonText="同行者登録" onClick={onClickRegistAccompany} className="membership_reserve_doukou_btn" />
                            }
                        </div>
                        <div className='membership_reserve_cancel_btn_area'>
                            <Button buttonText="予約をキャンセル" onClick={onClickCancel} className="membership_reservation_cancel_btn" />
                        </div>
                    </>
                    : null
                }
                <div className="backTop">
                    <Link className='membership_reserve_cancel_link' to={loginType === "MEMBER" ? "/reserve/hotel/search" : "/reserve/hotel/crawlSearch"} >ホテル検索TOPへ戻る</Link>
                </div>
            </div>
            <div><MembershipFooterContainer footerClass={"reservationResultFooterBase grayFooter"} /></div>
        </div >
    )
}

const styles = {
    top: {
        width: "100%",
        // paddingTop: "50px",
        // paddingBottom: "50px",
        backgroundColor: "#ebebeb",
        // backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (9.8rem + 100px))",
    },
    topCancel: {
        width: "100%",
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundColor: "#ebebeb",
        // backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // height: "calc(100vh - (7.1rem + 100px))",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        paddingTop: "15px",
        width: "70%",
        marginRight: "auto",
        marginLeft: "auto",
        paddingBottom: "40px"
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
    topGrayBorder: {
        borderTop: "solid 50px gray",
    },
}
const mapStateToProps = (state) => {
    return {
        login: state.login,
        membershipReserveComf: state.membershipReserveComf,
        membershipReserveInfo: state.membershipReserveInfo,
        membershipSearchParam: state.membershipSearchParam,
        resvKaiinken: state.resvKaiinken,
        serviceCheckInfo: state.serviceCheckInfo,
    };
};

const mapDisptchToProps = (dispatch) => {
    return {
        setMembershipReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_COMF", payload: { membershipReserveComf: item } })
        },
        setMealInfoList: (item) => {
            dispatch({ type: "MEAL_INFO_LIST", payload: { mealInfoList: item } })
        },
        setOtherMenuInfoList: (item) => {
            dispatch({ type: "OTHER_MENU_INFO_LIST", payload: { otherMenuInfoList: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setInputUserInfo: (item) => {
            dispatch({ type: "INPUT_USER_INFO", payload: { inputUserInfo: item } })
        },
        setMembershipReserveInfo: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_INFO", payload: { membershipReserveInfo: item } })
        },
        setRight: (item) => {
            dispatch({ type: "RIGHT", payload: { right: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
        setMembershipCancelReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_CANCEL_RESERVE_COMF", payload: { membershipCancelReserveComf: item } })
        },
    };
};

export default connect(mapStateToProps, mapDisptchToProps)(MembershipBookingConfirmDetailContainer);
